module.exports = __webpack_public_path__ + "public/img/用电量.568ebae2.png";